export default "__VITE_ASSET__CfjQ$09I__"